import projects from './json/table.projects.json';

export const tables = {
  projects,
};
